import { useState } from 'react';

import {
  SearchBarRangeDatePicker,
  SearchBarSingleDatePicker,
} from '@components/views/flight/listing/SearchBar/DateSelect/DateSelect';
import { FlightTripType } from '@components/views/flight/types';
import { DateType, formatMomentDate } from '@utils/dateUtil';
import ResponsiveSingleDateSelect from '@components/views/flight/listing/SearchBar/DateSelect/ResponsiveSingleDateSelect';
import ResponsiveDateRangeSelect from '@components/views/flight/listing/SearchBar/DateSelect/ResponsiveDateRangeSelect';
import { getDateRangePickerPlaceholder } from '@components/views/flight/listing/SearchBar/DateSelect/utils';
import { useDevice } from '@contexts/device';

import { BookerSearchBarDateRangeInputWrapper } from './style';

interface Dates {
  startDate?: DateType | null;
  endDate?: DateType | null;
}

interface Props {
  tripType: FlightTripType;
  initialDates?: Dates;
  dateChange: (dates?: Dates) => void;
  error?: boolean;
  isBookerSearch?: boolean;
  isHoliday?: boolean;
}

const BookerFlightDatePicker = ({
  tripType,
  dateChange,
  initialDates,
  error,
  isBookerSearch,
  isHoliday,
}: Props) => {
  const [localStartDate, setLocalStartDate] = useState<DateType | null>(
    initialDates?.startDate || null
  );
  const [localEndDate, setLocalEndDate] = useState<DateType | null>(
    initialDates?.endDate || null
  );

  const onDatesChange = ({
    startDate,
    endDate,
  }: {
    startDate: DateType | null;
    endDate: DateType | null;
  }) => {
    setLocalStartDate(startDate);
    setLocalEndDate(endDate);
    if (startDate && endDate) dateChange({ startDate, endDate });
  };

  const onDateChange = (date: moment.Moment | null) => {
    setLocalStartDate(date);
    dateChange({ startDate: date });
  };
  const { isDesktop } = useDevice();
  return (
    <BookerSearchBarDateRangeInputWrapper>
      {tripType === 'one-way' ? (
        isDesktop ? (
          <SearchBarSingleDatePicker
            date={localStartDate}
            onDateChange={onDateChange}
            error={error}
            isBookerSearch={isBookerSearch}
          />
        ) : (
          <ResponsiveSingleDateSelect
            date={localStartDate}
            onDateChange={onDateChange}
            title='Gidiş Tarihiniz?'
            subTitle={`${formatMomentDate(localStartDate)}`}
            placeholder='Gidiş Tarihi'
            drawerTitle='Tarih Arama'
            arrowIcon={true}
          />
        )
      ) : null}
      {tripType === 'round-trip' ? (
        isDesktop ? (
          <SearchBarRangeDatePicker
            minimumNights={0}
            startDate={localStartDate}
            endDate={localEndDate}
            onDatesChange={onDatesChange}
            error={error}
            isBookerSearch={isBookerSearch}
            isHoliday={isHoliday}
          />
        ) : (
          <ResponsiveDateRangeSelect
            startDate={localStartDate}
            endDate={localEndDate}
            onDatesChange={onDatesChange}
            title='Gidiş-Dönüş Tarihiniz?'
            subTitle={getDateRangePickerPlaceholder(
              localStartDate,
              localEndDate
            )}
            placeholder='Gidiş - Dönüş Tarihleri'
            drawerTitle='Tarih Arama'
            arrowIcon={true}
            isHoliday={isHoliday}
          />
        )
      ) : null}
    </BookerSearchBarDateRangeInputWrapper>
  );
};
export default BookerFlightDatePicker;
